export default __webpack_public_path__ + "static/media/ic_choose_service.24e6003b.svg";